import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';

interface PowerOutageScheduleLimitFilterButtonProps {
  testId?: string;
  className?: string;
  onClick?: React.Dispatch<React.SetStateAction<boolean>>;
  showFilter: boolean;
}

export const PowerOutageScheduleLimitFilterButton: React.FC<
  PowerOutageScheduleLimitFilterButtonProps
> = ({ testId, className, onClick, showFilter }) => {
  const { t } = useTranslation();
  const showFilterClassName = showFilter ? 'drop-shadow-2' : '';
  return (
    <div
      data-testid={testId}
      onClick={() => onClick?.((prev) => !prev)}
      className={`flex h-[30px] w-[77px] cursor-pointer items-center justify-center rounded-[5px] border border-dark-6 bg-white hover:bg-light-2 ${showFilterClassName} ${className}`}
    >
      <SVGImage name="filter-prefix" width={16} height={16} className="mr-1" />
      <span className="noto-medium-3 leading-[23px] text-dark-4">
        {t('overview.modal.limit.button', { context: 'filter' })}
      </span>
    </div>
  );
};
